module.exports = __webpack_public_path__ + "static/img/rz-23.60aa5db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rz-23.jpg
// module id = j5O5
// module chunks = 0